export default __webpack_public_path__ + "static/VR Games A New Way to Create Significant Safety Impact-c154f8be33c671384f784761dd897be1.jpg";